/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-04-17 22:40:30
 * @modify date 2022-04-19 20:49:38
 */
import { flow } from "mobx-state-tree"
import { ApiResult } from "services/api"
import { toString } from "lodash"

export const withCollectiveReportActions = (self: any) => ({
  actions: {
    setCollectiveReport(data) {
      const reports = data.map(d => {
        return {
          ...d,
          id: toString(d.id),
          sampleName: toString(d.sampleName),
          scores: JSON.stringify(d.scores),
          flavorWheelGroups: JSON.stringify(d.flavorWheelGroups),
          flavorWheelOnlyFragrance: JSON.stringify(d.flavorWheelOnlyFragrance),
          flavorWheelOnlyFlavor: JSON.stringify(d.flavorWheelOnlyFlavor),
          topFlavorWheelGroups: JSON.stringify(d.topFlavorWheelGroups),
          topFlavorWheelOnlyFragrance: JSON.stringify(d.topFlavorWheelOnlyFragrance),
          topFlavorWheelOnlyFlavor: JSON.stringify(d.topFlavorWheelOnlyFlavor),
          interestStatus : JSON.stringify(d.interestStatus)
        }
      })

      self.setValue('collectiveReports', reports)
    },
    getCollectiveReport: flow(function * (token) {
      try {
        if (!token) return

        const res: ApiResult = yield self.environment.collectiveReportApi.find(token)

        if (res.kind === "ok") self.setCollectiveReport(res.data)
      } catch (error: any) {
        yield self.checkForGeneralError(error)
      }
    }),

  }
})
